export default __webpack_public_path__ + "static/media/background2.caa5a74a.jpg";